module.exports = {
  "loginVerificationWithHSAuthenticator": {
    "name": "Login Verification with HubSpot Authenticator",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-verification-hs-authenticator-initiated",
        "login-verification-hs-authenticator-succeded",
        "login-verification-hs-authenticator-failed"
      ]
    },
    "namespace": "LoginUi"
  },
  "loginVerificationWithHSAuthResent": {
    "name": "Login Verification with HubSpot Authenticator resent after error",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-verification-hs-authenticator-resent"
      ]
    },
    "namespace": "LoginUi"
  },
  "loginVerificationWithHSAuthCode": {
    "name": "Login Verification with HubSpot Authenticator Code",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-verification-hs-authenticator-code-initiated",
        "login-verification-hs-authenticator-code-succeded"
      ]
    },
    "namespace": "LoginUi"
  },
  "remeberDevice": {
    "name": "Remember this device",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-and-remeber-device"
      ]
    },
    "namespace": "LoginUi"
  },
  "doNotRemeberDevice": {
    "name": "Do not remember this device",
    "class": "usage",
    "properties": {
      "action": "string",
      "type": [
        "login-and-do-not-remeber-device"
      ]
    },
    "namespace": "LoginUi"
  },
  "smartLoginPageOpened": {
    "name": "Smart Login page opened",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "smartLoginOptOut": {
    "name": "Smart Login Opt-Out",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "twoFactorRecoveryMobileAuth": {
    "name": "Recovery for Mobile Auth",
    "class": "interaction",
    "properties": {
      "action": "string",
      "type": [
        "hs-authenticator-recovery-lost",
        "hs-authenticator-recovery-new",
        "hs-authenticator-recovery-uninstalled"
      ]
    },
    "namespace": "LoginUi"
  },
  "loginPageView": {
    "name": "Page View for Login",
    "class": "view",
    "namespace": "LoginUi"
  },
  "signupLinkClick": {
    "name": "Signup Link Click",
    "class": "interaction",
    "namespace": "LoginUi"
  },
  "vettingPageView": {
    "name": "Page View for Vetting",
    "class": "view",
    "namespace": "LoginUi"
  },
  "smartLoginPasswordLoginClick": {
    "name": "Smart Login password login click",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "smartLoginPasskeyLoginClick": {
    "name": "Smart Login passkey login click",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "smartLoginGoogleLoginClick": {
    "name": "Smart Login google login click",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "smartLoginAppleLoginClick": {
    "name": "Smart Login apple login click",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "smartLoginMicrosoftLoginClick": {
    "name": "Smart Login microsoft login click",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "smartLoginSsoLoginClick": {
    "name": "Smart Login sso login click",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "forgotPasswordClick": {
    "name": "Forgot my password click",
    "class": "usage",
    "namespace": "LoginUi"
  },
  "passwordResetClick": {
    "name": "Reset your password click",
    "class": "usage",
    "namespace": "LoginUi"
  }
};